import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@components/atoms';

export const Main = memo(({ onStart }) => {
  return (
    <div className="flex flex-col space-y-2 lg:space-y-10 justify-center items-center">
      <div className="flex flex-col lg:space-y-0 lg:space-x-8 lg:flex-row w-full items-center">
        <div className="antialiased font-light">
          <h1 className="text-5xl mb-6">
            Think you have the next big product idea?
          </h1>
          <div className="text-2xl text-slate-500 space-y-5">
            <div className="">
              Evaluate if it&#39;s worth developing with this powerful AI tool.
            </div>
            <div className="">
              We will not ask you any questions that could give away your
              product idea.
            </div>
          </div>
        </div>
        <div
          className="w-full h-80 bg-contain bg-no-repeat bg-center"
          style={{
            backgroundImage:
              'url(https://www.makexnow.com/uploads/4/2/6/1/42615509/main-image_orig.png)',
          }}
        />
      </div>
      <div className="text-slate-500 space-x-2 text-sm">
        <Icon name="timer" />
        <span>Takes 3 Minutes</span>
      </div>
      <Button onClick={onStart}>Start Questions</Button>
    </div>
  );
});

Main.propTypes = {
  onStart: PropTypes.func,
};
